module.exports = __webpack_public_path__ + "img/login-bg1.985af674.jpg";